import { Link } from 'react-router-dom'
import { ChevronRight, Wallet } from 'lucide-react'
import { ROUTES } from '@/routes/routes'
import { cn } from '@/lib/utils'

export function NetWorthRow({ value, className }: { value: string; className?: string }) {
  return (
    <section className={cn('flex flex-col justify-center', className)}>
      <Link
        to={ROUTES.APP.ACCOUNTS}
        className="group flex min-h-12 items-center gap-3 lg:min-h-14 lg:gap-5"
        aria-label={`Net worth ${value}`}
      >
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-[var(--fl-primary-subtle)] text-[var(--fl-primary)] lg:h-14 lg:w-14 lg:rounded-2xl">
          <Wallet size={22} aria-hidden="true" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-[11px] font-semibold uppercase tracking-wider text-[var(--fl-text-2)] lg:text-xs">
            Net worth
          </span>
          <span className="mt-0.5 block truncate font-serif text-2xl font-bold leading-tight text-[var(--fl-heading)] lg:text-[40px]">
            {value}
          </span>
        </span>
        <ChevronRight
          size={18}
          className="shrink-0 text-[var(--fl-text-3)] group-hover:text-[var(--fl-heading)]"
          aria-hidden="true"
        />
      </Link>
    </section>
  )
}
